import { faXmark, faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import {
  BtnClose, Dialog
  , DialogContent, DialogTitle, Line, MLabel, Overlay
  , TextContent
  , TextTile,
  InputText,
  InputDate
} from './styles'
import { Box, Button, Stack, } from "@mui/material";
import { INV_HISTORY_ACTION_TYPE, MESSAGE } from "Common";
import inventoryApi from "api/inventoryApi";
import dayjs from "dayjs";

const DialogEditInvHistory = ({ invHistory, handleClose, setIsLoading, setReload, setMessage }) => {
  const [quantity, setQuantity] = useState(0);
  const [dateChange, setDateChange] = useState();

  const handleDialogClose = () => {
    setQuantity(0);
    setDateChange(null);
    handleClose();
  }

  const handleSave = async () => {
    //登録処理
    try {
      setIsLoading(true);
      /**Call Api */
      const params = {
        id: invHistory?.ClientInventoryHistoryID || 0,
        q: (quantity || parseInt(invHistory?.NumberQ)) * (invHistory?.ActionType === 'add' ? 1 : -1),
        d: dateChange || dayjs(invHistory?.ActionDate).format('YYYY-MM-DD')
      }
      const res = await inventoryApi.updateInventoryHistory(params);
      const HistoryID = parseInt(res?.data?.HistoryID || 0);
      if (HistoryID < 1) {
        const msg = {
          contents: ['在庫数の変更に失敗しました。'],
          type: MESSAGE.ERROR
        }
        setMessage(msg);
      }
      //reload
      setReload(prev => !prev);
    } catch (error) {
      const msg = {
        contents: [error],
        type: MESSAGE.ERROR
      }
      setMessage(msg);
    } finally {
      setIsLoading(false);
      handleDialogClose();
    }

  }

  return <>
    {invHistory?.ClientInventoryHistoryID && (<>
      <Dialog>
        <DialogTitle>
          <TextTile>{"在庫履歴編集"}</TextTile>
          <BtnClose onClick={() => { handleDialogClose(); }}><FontAwesomeIcon icon={faXmark} /></BtnClose>
        </DialogTitle>
        <DialogContent>
          <TextContent>
            <Line>
              <MLabel>履歴データ：</MLabel>
              <Box ml={1} mb={2}>
                {`${INV_HISTORY_ACTION_TYPE[invHistory.ActionType]}日：${dayjs(invHistory?.ActionDate).format('YYYY/MM/DD')}　｜在庫数：${invHistory.NumberQ}`}
              </Box>
            </Line>

            <Line>
              <MLabel style={{ display: "inline-block", width: "80px" }}>日付：</MLabel>
              <InputDate value={dateChange || dayjs(invHistory?.ActionDate).format('YYYY-MM-DD')}
                onChange={(e) => setDateChange(e.target.value)}
              />
            </Line>
            <Line style={{ marginTop: "4px" }}>
              <MLabel style={{ display: "inline-block", width: "64px" }}>在庫数：</MLabel>
              {
                invHistory?.ActionType === 'add' ? (<FontAwesomeIcon icon={faPlus} />) :
                  (<FontAwesomeIcon icon={faMinus} />)
              }
              <InputText id={'quantity'} value={quantity === 0 ? "" : quantity}
                style={{ marginLeft: "4px" }}
                autoComplete="off"
                onChange={(e) => {
                  const val = parseInt(e.target.value) || 0;
                  setQuantity(val);
                }} />
            </Line>
          </TextContent>

          <Stack direction="row" spacing={2} mt={1}  >
            <Button variant="outlined" color="secondary" onClick={() => { handleDialogClose() }}>キャンセル</Button>
            <Button variant="contained" color="primary" sx={{ minWidth: "100px" }} onClick={() => { handleSave(); }}
            >変更</Button>
          </Stack>
        </DialogContent>
      </Dialog>
      <Overlay /></>)
    }
  </>;
};

export default DialogEditInvHistory
